export function formatedDate (date:string) {
    const dateArray = date.slice(0,10).split(/-/g)
    const time = date.slice(11,19)
    const formatedDate = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0] + ' ' + time
    return formatedDate
}